import { CSSObject } from '@emotion/react'
import {
  AlignItems,
  Box,
  Display,
  Image,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import React from 'react'

export type LargeImageWithTextProps = {
  children: React.ReactNode
  desktopSrc: string
  mobileSrc: string
  altText: string
}

const Container = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(['column-reverse', null, null, 'row'], ['flexDirection']) as CSSObject),
}))

export function LargeImageWithText({
  children,
  desktopSrc,
  mobileSrc,
  altText,
}: LargeImageWithTextProps) {
  return (
    <Container
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.SpaceEvenly}
      paddingH={[8, 20]}
      paddingV={16}
      paddingBottom={6}
      gap={[4, 8]}
    >
      <Box width={['auto', null, null, '600px']} height={['auto', null, null, '900px']}>
        <picture>
          <source srcSet={desktopSrc} media="(min-width: 1024px)" />
          <source srcSet={mobileSrc} />
          <Image style={{ borderRadius: '8px' }} fit="cover" alt={altText} src={mobileSrc} />
        </picture>
      </Box>

      <Box width={[null, null, null, '600px']} paddingBottom={[3, 4]}>
        {children}
      </Box>
    </Container>
  )
}
